import config from '~/common/config/config'
import { auth } from '~/common/lib/firebase'

/**
 * Forces logout from all auth providers and redirects to login.
 * This is a "nuclear" logout that clears everything regardless of current provider.
 *
 * Note: Apollo cache clearing should be handled by the caller if needed,
 * to avoid circular dependencies with apollo-client.
 */
export const forceLogout = async (): Promise<void> => {
  try {
    await auth.signOut()
  } catch {
    // Ignore errors signing out from Firebase
  }

  try {
    await fetch(`${config.apiUrl}/unauthenticated/auth/workos/sign-out`, {
      method: 'POST',
      credentials: 'include',
    })
  } catch {
    // Ignore errors clearing WorkOS session
  }

  // Clear any auth-related localStorage
  localStorage.removeItem('workos_auth_event')
  localStorage.removeItem('firebase_logout_event')
  localStorage.removeItem('doss_auth_version')

  // Redirect to login page
  window.location.href = '/auth/login'
}
